<div mat-dialog-title>
  แก้ไขวันหยุด

</div>
<mat-dialog-content class="mat-typography">
  <br>
  <mat-slide-toggle [(ngModel)]="openOnWeekends" color="primary">
    <span *ngIf="openOnWeekends">เปิดให้บริการวันเสาร์อาทิตย์</span>
    <span *ngIf="!openOnWeekends">หยุดให้บริการวันเสาร์อาทิตย์</span>
  </mat-slide-toggle>
  <form class="date-form" #form [formGroup]="fg">
    <mat-form-field>
      <mat-label>เลือกวันที่</mat-label>
      <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="picker" formControlName="date">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    &nbsp;
    <mat-form-field class="long">
      <mat-label>ระบุชื่อวันหยุด</mat-label>
      <input matInput formControlName="name">
    </mat-form-field>
    <button mat-button (click)="addDate()">
      <mat-icon>add</mat-icon> เพิ่มวันหยุด
    </button>
    <input type="file" class="not-display" #fileUpload (change)="importCSV($event)">
    <button mat-button (click)="fileUpload.click()">
      <mat-icon>cloud_upload</mat-icon> Import
    </button>
    <button mat-button (click)="exportDatesToCSV()">
      <mat-icon>cloud_download</mat-icon> Export
    </button>
    <ng-container *ngIf="errorMessage">
      <br>
      <span class="error">&nbsp;{{ errorMessage }}</span>
    </ng-container>
  </form>
  <!-- <span>
    <button mat-button class="long-button" (click)="addGoogleHolidays()">
      <mat-icon>calendar_today</mat-icon> เพิ่มวันหยุดตามปีปฏิทิน
    </button>

  </span> -->

  <div class="date-list-container">
    <mat-list dense class="date-list">
      <mat-divider></mat-divider>
      <mat-list-item *ngIf="!openOnWeekends">
        <span> ทุกวันเสาร์และวันอาทิตย์ </span>
        <div class="flex-spacer"></div>
        <button disabled mat-icon-button color="warn">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-list-item>
      <ng-container *ngFor="let date of dates; let i=index;">
        <mat-divider></mat-divider>
        <mat-list-item>
          <span>{{ formatDate(date.date) }} ({{ date.name }}) </span>
          <div class="flex-spacer"></div>
          <button mat-icon-button color="warn" (click)="deleteDate(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </mat-list-item>
      </ng-container>
    </mat-list>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>ยกเลิก</button>
  <button mat-raised-button class="submit-button" [mat-dialog-close]="{holidays: dates, openOnWeekends: openOnWeekends}"
    cdkFocusInitial>บันทึก</button>
</mat-dialog-actions>
